"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.HOOK_TRIGGER_FIELDS, (table)=>{
        table.string('fk_hook_id', 20).notNullable();
        table.string('fk_column_id', 20).notNullable();
        table.string('base_id', 20).notNullable();
        table.string('fk_workspace_id', 20).notNullable();
        table.timestamps(true, true);
        table.primary([
            'fk_workspace_id',
            'base_id',
            'fk_hook_id',
            'fk_column_id'
        ]);
    });
    await knex.schema.alterTable(_globals.MetaTable.HOOKS, (table)=>{
        table.boolean('trigger_field').defaultTo(false);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.HOOK_TRIGGER_FIELDS);
    await knex.schema.alterTable(_globals.MetaTable.HOOKS, (table)=>{
        table.dropColumn('triggerField');
    });
};
